export const SimilarProductRecommendations = "48b225e07e0836a3ddc87a918c6aacff4dc0716ffbc874eb6ab236f7b3c37e28";